import { getGlobalScope } from '@amplitude/analytics-core';
// These functions are not exposed in rrweb package, so we will define it here to use
// Ignoring this function since this is copied from rrweb
export function getWindowHeight() {
    var globalScope = getGlobalScope();
    return ((globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerHeight) ||
        (document.documentElement && document.documentElement.clientHeight) ||
        (document.body && document.body.clientHeight) ||
        0);
}
export function getWindowWidth() {
    var globalScope = getGlobalScope();
    return ((globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerWidth) ||
        (document.documentElement && document.documentElement.clientWidth) ||
        (document.body && document.body.clientWidth) ||
        0);
}
//# sourceMappingURL=rrweb.js.map